module.exports = __webpack_public_path__ + "static/media/tension_clamp_snail_type.13eb56c2.webp";